import React, { useState } from "react";
import LearnosityPassageEditor from "./learnosityPassageEditor";
import LearnosityPassageEditorES from "./LearnositySpanishPassageEditor";

export default function PassageEditorTabs(props: any) {
  const [activeTab, setActiveTab] = useState<number>(1);
  const activeTabClass =
    "text-gray-900 topBorder bg-white border border-b-0 group relative min-w-0 flex-1 mb-0 overflow-hidden py-4 px-4 text-sm font-medium text-center hover:bg-gray-50 dark:hover:bg-gray-700 focus:z-10";
  const inActiveTabClass =
    "text-gray-500 hover:text-gray-700 group relative min-w-0 flex-1 overflow-hidden mb-0 py-4 px-4 text-sm font-medium text-center hover:bg-gray-50 focus:z-10";

  return (
    <>
      <div className="mt-10 flex items-center justify-between bg-gray-100 w-full">
        <div className="flex">
          <button
            type="button"
            onClick={() => {
              setActiveTab(1);
              props.SetSpanishPassageData();
              props.setIsLrnSpanishEditorLoaded(false);
              props.setIsLrnSpanishPaginated(false);
              props.setSelectedLanguage("EN");
            }}
          >
            <h2 className={activeTab === 1 ? activeTabClass : inActiveTabClass}>
              English Passage
            </h2>
          </button>
          <button
            type="button"
            onClick={() => {
              setActiveTab(2);
              props.SetEnglishPassageData();
              props.setIsLrnEditorLoaded(false);
              props.setIsLrnPaginated(false);
              props.setSelectedLanguage("ES");
            }}
          >
            <h2 className={activeTab === 2 ? activeTabClass : inActiveTabClass}>
              Spanish Passage
            </h2>
          </button>
        </div>
      </div>

      {activeTab === 1 && (
        <div className="flex flex-row shadow border-b border-gray-200 rounded-b-lg space-x-8 justify-between w-full p-4">
          <div className="w-full">
            <h2 className="mb-0">
              <div> Word Count: {props.englishWordCount}</div>
              <LearnosityPassageEditor
                authorAppParent={props.authorAppParent}
                widgetPsgDataEN={props.widgetPsgDataEN}
                setWidgetPsgEN={props.setWidgetPsgEN}
                englishPsgReferenceId={props.englishPsgReferenceId}
                setIsLrnEditorLoaded={props.setIsLrnEditorLoaded}
                setIsLrnPaginated={props.setIsLrnPaginated}
                setLoading={props.setLoading}
              ></LearnosityPassageEditor>
            </h2>
            {props.englishPassage === "" && props.errorMessage === true && (
              <span className="text-red-700 inline-block pt-1 text-sm">
                English Passage is required
              </span>
            )}
          </div>
          <div className="w-100">
            <div>
              <h4 className="text-gray-700">Notes</h4>
              <textarea
                name="notes"
                value={props.notes}
                onChange={props.notesChangeHandler}
                className="resize border border-gray-300 rounded-md w-full h-16 dark:focus:border-gray-500 dark:focus:ring-gray-500 dark:bg-custom-black dark:text-white "
              />
              {props.notes === "" && props.errorMessage === true && (
                <span className="text-red-700 inline-block text-sm">
                  Notes is required
                </span>
              )}
            </div>

            <div className="mt-2">
              <h4 className="text-gray-700">TTS Passage</h4>
              <textarea className="resize border border-gray-300 rounded-md w-full h-16 dark:focus:border-gray-500 dark:focus:ring-gray-500 dark:bg-custom-black dark:text-white"></textarea>
            </div>
            <dl className="mt-2">
              <label
                htmlFor="toogleA"
                className="flex items-center cursor-pointer pl-1"
              >
                <div className="relative">
                  <input
                    id="toogleA"
                    type="checkbox"
                    className="sr-only"
                    onChange={(e) =>
                      props.setIsHumanTranslated(e.target.checked)
                    }
                  />
                  <div className="w-10 h-4 bg-gray-400 rounded-full shadow-inner"></div>
                  <div
                    className={`${
                      props.isHumanTranslated
                        ? "bg-primary-color toggle-btn"
                        : ""
                    } absolute w-6 h-6 bg-white rounded-full shadow -left-1 -top-1 transition`}
                  ></div>
                </div>
                <div className="ml-3 text-gray-700 font-medium">
                  Human Translated
                </div>
              </label>
            </dl>
          </div>
        </div>
      )}

      {activeTab === 2 && (
        <div className="flex flex-row shadow border-b border-gray-200 rounded-b-lg space-x-8 justify-between w-full p-4">
          <div className="w-full">
            <h2 className="mb-0">
              <div> Word Count: {props.spanishWordCount}</div>
              <LearnosityPassageEditorES
                authorAppParentES={props.authorAppParentES}
                widgetPsgDataEN={props.widgetPsgDataEN}
                widgetPsgDataES={props.widgetPsgDataES}
                setWidgetPsgEN={props.setWidgetPsgEN}
                setWidgetPsgES={props.setWidgetPsgES}
                spanishPsgReferenceId={props.spanishPsgReferenceId}
                widgetDataOnLoad={props.widgetDataOnLoad}
                App={props.App}
                setIsLrnSpanishEditorLoaded={props.setIsLrnSpanishEditorLoaded}
                setIsLrnSpanishPaginated={props.setIsLrnSpanishPaginated}
                setLoading={props.setLoading}
              ></LearnosityPassageEditorES>
            </h2>
          </div>
          <div className="w-100">
            <div>
              <h4 className="text-gray-700">Notes</h4>
              <textarea
                name="Spanish Notes"
                defaultValue={props.notesES}
                onChange={props.notesESChangeHandler}
                className="resize border border-gray-300 rounded-md w-full h-16 dark:focus:border-gray-500 dark:focus:ring-gray-500 dark:bg-custom-black dark:text-white"
              />
            </div>
            <div className="mt-3">
              <h4 className="text-gray-700">TTS Passage</h4>
              <textarea className="resize border border-gray-300 rounded-md w-full h-16 dark:focus:border-gray-500 dark:focus:ring-gray-500 dark:bg-custom-black dark:text-white"></textarea>
            </div>
            <dl className="mt-2">
              <label
                htmlFor="toogleA"
                className="flex items-center cursor-pointer pl-1"
              >
                <div className="relative">
                  <input
                    id="toogleA"
                    type="checkbox"
                    className="sr-only"
                    onChange={(e) =>
                      props.setIsHumanTranslated(e.target.checked)
                    }
                  />
                  <div className="w-10 h-4 bg-gray-400 rounded-full shadow-inner"></div>
                  <div
                    className={`${
                      props.isHumanTranslated
                        ? "bg-primary-color toggle-btn"
                        : ""
                    } absolute w-6 h-6 bg-white rounded-full shadow -left-1 -top-1 transition`}
                  ></div>
                </div>
                <div className="ml-3 text-gray-700 font-medium">
                  Human Translated
                </div>
              </label>
            </dl>
          </div>
        </div>
      )}
    </>
  );
}
